import React from 'react';
import Loading from '../components/Loading';
import { ListStyled, ListItem } from '../../css/styles/list';
import { IoMdTrash } from 'react-icons/io';
import { FormStyled } from '../../css/styles/form';
function equipmentList(props) {
  const { equipments, loadingList, pageIndex, setPageIndex } = props;
  const itemsPerPage = 14;
  const start = pageIndex * itemsPerPage;
  const end = start + itemsPerPage;
  const currentItems = equipments.slice(start, end);
  let alreadyCalled = false;

  // Lógica p/ selecionar o item quando a lista retornar somente 1 elemento.
  if (equipments.length === 1 && !alreadyCalled) {
    alreadyCalled = true;
    setTimeout(() => {
      props.onEdit(equipments[0]);
    }, 0);
  }

  if (equipments.length !== 1) {
    alreadyCalled = false;
  }
  return (
    <>
      {!loadingList ? (
        equipments.length > 0 ? (
          <ListStyled>
            <header>
              <div className="total">
                <h1>TOTAL:</h1>
                <p>{equipments.length}</p>
              </div>
              <div className="pagination-buttons">
                <button
                  type="button"
                  onClick={() => setPageIndex(Math.max(pageIndex - 1, 0))}
                  disabled={pageIndex === 0}
                  style={{
                    marginRight: '10px',
                    backgroundColor: pageIndex === 0 && '#ccc',
                  }}
                >
                  ◀
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setPageIndex(
                      end >= equipments.length ? pageIndex : pageIndex + 1
                    )
                  }
                  disabled={end >= equipments.length}
                  style={{
                    backgroundColor:
                      pageIndex === Math.ceil(equipments.length / 14) - 1 &&
                      '#ccc',
                  }}
                >
                  ▶
                </button>
              </div>
            </header>

            {currentItems.map(item => (
              <ListItem color="#011826" strongColor="#fff" key={item.uuid}>
                <div
                  className="info"
                  onClick={() => {
                    props.onEdit(item);
                  }}
                >
                  <div>
                    <strong className="title">CÓDIGO: </strong>
                    <strong>{item.code || '-'}</strong>
                  </div>
                  <div>
                    <strong className="title">DATA: </strong>
                    <strong>
                      {new Date(item.createdAt).toLocaleDateString('pt-BR', {
                        timeZone: 'UTC',
                      })}
                    </strong>
                  </div>
                  <div>
                    <strong className="title">ANO: </strong>
                    <strong>{item.year || '-'}</strong>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={e => {
                    e.stopPropagation();
                    props.onDelete(item.uuid);
                  }}
                  className="delete"
                >
                  <IoMdTrash size={20} color="#bf1523" />
                </button>
              </ListItem>
            ))}
          </ListStyled>
        ) : (
          <strong>LISTA VAZIA</strong>
        )
      ) : (
        <strong>CARREGANDO...</strong>
      )}
    </>
  );
}

export default equipmentList;

